import MuiLink from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import { alpha, styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { NavItem } from '@qpr/components/Expandable/nav-items-view-model';
import React from 'react';
import { Link } from 'react-router-dom';
import { checkIfExternal } from '../../../utils/url-utils';

const PREFIX = 'MenuContent';

const classes = {
  itemStyle: `${PREFIX}-itemStyle`,
  itemDisabledStyle: `${PREFIX}-itemDisabledStyle`,
  linkStyle: `${PREFIX}-linkStyle`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.itemStyle}`]: {
    color: 'white',
    background: theme.palette.primary.main
  },

  [`& .${classes.itemDisabledStyle}`]: {
    background: theme.palette.primary.main,
    color: alpha(theme.palette.getContrastText(theme.palette.text.primary), 0.38)
  },

  [`& .${classes.linkStyle}`]: {
    textDecoration: 'none',
    '&:hover': {
      background: theme.palette.primary.dark
    }
  }
}));

interface MenuContentProps {
  item: NavItem;
  typographyVariant: TypographyProps['variant'];
  setItemDescription: React.Dispatch<React.SetStateAction<string | undefined>>;
  tenantSymbol: string;
  onClose: () => void;
}

const MenuContent = ({
  item = { _id: 0, title: '', link: '', enabled: false, children: [] },
  typographyVariant = 'body1',
  setItemDescription = () => {
    return null;
  },
  tenantSymbol = 'body1',
  onClose
}: MenuContentProps) => {
  const content = (
    <ListItem
      onMouseEnter={() => setItemDescription((item.enabled && item.description) || '')}
      onMouseLeave={() => setItemDescription('')}
      onFocus={() => setItemDescription((item.enabled && item.description) || '')}
      onBlur={() => setItemDescription('')}
      style={{ textDecorationLine: 'none!important' }}
      className={
        // eslint-disable-next-line no-nested-ternary
        item.enabled
          ? item.link !== undefined && item.link !== ''
            ? `${classes.itemStyle} ${classes.linkStyle}`
            : classes.itemStyle
          : classes.itemDisabledStyle
      }
    >
      <Typography variant={typographyVariant} data-testid="menu-title">
        {item.title}
      </Typography>
    </ListItem>
  );
  if (item.enabled && item.link !== undefined && item.link !== '') {
    if (checkIfExternal(item.link)) {
      return (
        <Root>
          <MuiLink
            onClick={onClose}
            target="_blank"
            rel="noopener noreferrer"
            href={item.link}
            data-testid="link-external"
            className={classes.linkStyle}
            underline="none"
          >
            {content}
          </MuiLink>
        </Root>
      );
    }
    return (
      <Root>
        <Link
          style={{ textDecorationLine: 'none' }}
          onClick={onClose}
          to={`/${tenantSymbol}${item.link}`}
          data-testid="link-internal"
          className={classes.linkStyle}
        >
          {content}
        </Link>
      </Root>
    );
  }

  return <Root>{content}</Root>;
};

export default MenuContent;
